import _ from 'lodash';
import React from 'react';
import clientApprovalStatuses from '~/lookups/client-approval-statuses';
import MultiSelect from '../MultiSelect';

const options = _.values(clientApprovalStatuses);

export default function ClientApprovalStatusFilter({ placeholder = 'Client Approval Status', name, value, onChange }) {
  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
